module.exports = __webpack_public_path__ + "static/media/default.348f6db0.png";